import axios from 'axios';

const getClientApiUrl = () => {
  if (typeof window !== 'undefined' && window.env && window.env === 'production') {
    return '/api/';
  }
  return '/bunnings/api/';
};

export const api = axios.create({
  baseURL:
    typeof SERVER === 'undefined' || SERVER // eslint-disable-line no-undef
      ? `http://localhost:${typeof PORT === 'undefined' ? '10010' : PORT}/bunnings/api/` // eslint-disable-line no-undef
      : getClientApiUrl()
});
